<template>
	<div class="seachBox">
		<div class="input" @click.stop="showSelect()">
			<i class="el-icon-search"></i>
			<input type="text" v-model="val" />
			<span @click="search()">确定</span>
			<ul v-if="isshow">
				<li v-for="(data,i) in datas1" :key="i">
					<span>{{data.title}}--{{data.title1}}</span>
					<span class="checkbox" @click="toggle(data.i,data.index,data.checked,data)" :class="{'checked':data.checked}"></span>
				</li>
			</ul>
		</div>

	</div>

</template>

<script>
	export default {
		name: "searchBox",
		props: {
			dynamicColumn: {
				type: Array,
			}
		},
		data() {
			return {
				datas: [],
				val: '',
				isshow: false,
			};
		},
		created() {
			for (let i = 0; i < this.dynamicColumn.length; i++) {
				this.dynamicColumn[i].dataList.forEach((item, index) => {

					var isActive = this.dynamicColumn[i].grounpColumns.filter((column) => {
						return column.title == item.title
					})
					if (isActive.length > 0) {
						item.checked = true;
					} else {
						item.checked = false;
					}
					item.i = i;
					item.index = index;
					item.title1 = this.dynamicColumn[i].title;
				});
				console.log(this.dynamicColumn[i].dataList)
				this.datas = this.datas.concat(this.dynamicColumn[i].dataList);
			}
		},
		watch: {
			dynamicColumn: { //深度监听，可监听到对象、数组的变化
				handler(val, oldVal) {
					this.datas = [];
					for (let i = 0; i < this.dynamicColumn.length; i++) {
						this.dynamicColumn[i].dataList.forEach((item, index) => {

							var isActive = this.dynamicColumn[i].grounpColumns.filter((column) => {
								return column.title == item.title
							})
							if (isActive.length > 0) {
								item.checked = true;
							} else {
								item.checked = false;
							}
							item.i = i;
							item.index = index;
							item.title1 = this.dynamicColumn[i].title;
						});
						this.datas = this.datas.concat(this.dynamicColumn[i].dataList);
					}
				},
				deep: true //true 深度监听
			}
		},
		methods: {
			toggle(i, index, checked, data) {
				if (checked) {
					this.dynamicColumn[i].grounpColumns.splice(index, 1);
				} else {
					this.dynamicColumn[i].grounpColumns.splice(index, 0, data)
				}
			},
			showSelect() {
				this.isshow = true;
			}
		},
		mounted() {
			document.addEventListener('click', () => {
				this.isshow = false;
			})
		},
		computed: {
			datas1() {
				return this.datas.filter((data) => {
					return data.title.indexOf(this.val) != '-1';
				})
			},

		},

	};
</script>

<style scoped>
	.seachBox {
		margin-right: 60px;
		position: relative;
		z-index: 30;
		width: 250px;
		box-sizing: border-box;
	}

	.seachBox>.input {
		border: 1px solid rgba(216, 216, 216, 1);
		padding: 4px;
		border-radius: 6px;
		background: #fff;
	}

	.seachBox .input i {
		color: rgba(202, 202, 202, 1);
	}

	.seachBox .input input {
		border: none;
		outline: none;
		height: 20px;
		line-height: 28px;
		box-sizing: border-box;
		margin: 0 10px;
		width: 140px;
		border-bottom: 1px solid rgba(216, 216, 216, 1);
		font-weight: 400;
		color: rgba(102, 102, 102, 1);
	}

	.seachBox .input>span {
		display: inline-block;
		width: 55px;
		height: 24px;
		line-height: 24px;
		text-align: center;
		background: rgba(94, 213, 200, 1);
		border-radius: 15px;
		font-size: 12px;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		cursor: pointer;
	}

	ul {
		max-height: 200px;
		overflow: auto;
		width: 240px;
	}

	ul li {
		display: flex;
		padding: 0 20px 0 30px;
		justify-content: space-between;
		line-height: 26px;
		align-items: center;
	}

	ul li span {
		font-size: 12px;
		font-weight: 400;
		color: rgba(102, 102, 102, 1);
		line-height: 26px;
		display: inline-block;
		width: 160px;
	}

	.checkbox {
		display: inline-block;
		box-sizing: border-box;
		width: 13px;
		height: 13px;
		border-radius: 2px;
		border: 1px solid rgba(220, 220, 220, 1);
		position: relative;
		cursor: pointer;
	}

	.checkbox.checked::after {
		content: '';
		position: absolute;
		width: 20px;
		height: 15px;
		background: url('../../../../assets/img/dataImport/dui.svg') no-repeat;
		top: -4px;
		background-size: 100%;
	}
</style>
